import { type ISignCollectResponse } from '../../../../../models/sign-collect-response';
import { SignCollectStatusHelper } from '../../../../../models/sign-collect-status.enum';

export class SignCollectResponseApiModel {
  public static mapToBusinessModel(apiModel: SignCollectResponseApiModel): ISignCollectResponse {
    return {
      transactionId: apiModel.transactionId,
      status: SignCollectStatusHelper.parse(apiModel.status),
      qrCode: apiModel.qrCode,
    };
  }

  public transactionId!: string;
  public status!: string;
  public qrCode!: string;
}
